export default __webpack_public_path__ + "static/product-img1-314d650398b78b2c6bc4ba7abe25d458.png";